import React from "react";

import { getTranslation } from "../../../../helpers/getLanguage";
import "./styles.css";

export const IdeaModalFooter = ({ deleteIdea, isCompleted, checkRating, currentTab, isDisabledSave = true }) => {
  const getClassNameForSaveButton = () => {
    if (currentTab === 1) {
      return " dark-blue-btn";
    }

    if (currentTab === 2 && isCompleted()) {
      return " dark-blue-btn";
    }

    return " outlined";
  };

  return (
    <div className="idea-dialog-footer flex justify-space-between align-center ">
      <button className="idea-dialog-button delete" onClick={deleteIdea}>
        <span>{getTranslation("IDEA_MODAL_BUTTON_DELETE")}</span>
      </button>

      <button
        className={"idea-dialog-button " + getClassNameForSaveButton()}
        onClick={checkRating}
        disabled={isDisabledSave}
      >
        <span>{getTranslation("IDEA_MODAL_BUTTON_SAVE")}</span>
      </button>
    </div>
  );
};
